import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MapInfoWindow, MapMarker} from "@angular/google-maps";
import {arrayIsSet} from "../../../providers/service/global-variables.service";
import {MarkerType, TypeZoomType, typeZoomValue} from "../map/map.component";
import {Subject} from "rxjs";


@Component({
    selector: 'app-map-to-search',
    templateUrl: './map-to-search.component.html',
    styleUrls: ['./map-to-search.component.scss'],
    standalone: false
})
export class MapToSearchComponent implements OnInit, OnChanges {
    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow | undefined;
    options: google.maps.MapOptions = {
        center: {lat: 40, lng: -20},
        zoom: 4,
        mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    private map: google.maps.Map | undefined
    @Input() markers: MarkerType[] | undefined;
    @Input() center: MarkerType | undefined | null;
    @Input() pointer: MarkerType | undefined | null;
    @Input() typeZoom: { type: TypeZoomType } | undefined | null;
    @Output() clickButton = new EventEmitter<{ action: any }>()
    @Output() mapReady = new EventEmitter<google.maps.Map>()
    @Output() dragEnd = new Subject<google.maps.MapMouseEvent>()
    @Output() clickMap = new Subject<google.maps.MapMouseEvent | google.maps.IconMouseEvent>()

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.typeZoom != null) {
            this.changeZoom();
        }

        setTimeout(() => {
            if (changes.center != null && this.center?.location != null) {
                this.map?.setCenter(this.center?.location)
                this.map?.setZoom(19)
            }
        });
    }

    openInfoWindow(marker: MapMarker) {
        this.infoWindow?.open(marker);
    }

    clickInfoWindowButton(action: string) {
        this.clickButton.next({action})
    }

    mapIsReady(event: google.maps.Map) {
        this.map = event;
        this.mapReady.next(event);
        this.fitBounds()
    }

    fitBounds() {
        if (arrayIsSet(this.markers) && this.map != null) {
            let bounds = new google.maps.LatLngBounds();
            this.markers.forEach(marker => {
                const bound = new google.maps.LatLng(marker.location)
                bounds.extend(bound);
            })
            this.map?.fitBounds(bounds)
        }
    }

    changeZoom() {
        if (this.typeZoom?.type === typeZoomValue.fitBound) {
            this.fitBounds();
        }
    }

    moveMarker(event: google.maps.MapMouseEvent) {
        this.dragEnd.next(event);
    }

    clickOnMap(event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
        this.clickMap.next(event);
    }
}
